import { ChangeDetectionStrategy, Component, inject, signal } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { RouterModule } from '@angular/router';
import { InventoryService } from '@app/services/inventory/inventory.service';
import { TranslateModule } from '@ngx-translate/core';
import { InventoryItemModalComponent } from './modal-dialog/inventory-item-modal/inventory-item-modal.component';
import { UploadInventoryModalComponent } from './components/upload-inventory-modal/upload-inventory-modal.component';
import { UPLOAD_INVENTORY_DIALOG_CONFIG } from '@app/utils/constants/inventory-table.constant';

type InventoryTab = 'itemsList' | 'uploadItems';

@Component({
  selector: 'app-inventory',
  standalone: true,
  imports: [TranslateModule, RouterModule],
  templateUrl: './inventory.component.html',
  styleUrl: './inventory.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class InventoryComponent {
  private readonly inventoryService = inject(InventoryService);
  private readonly dialog = inject(MatDialog);

  public readonly isEmpty = this.inventoryService.isEmptyInventory;
  public activeTab = signal<InventoryTab>('itemsList');

  public setActiveTab(activeTab: InventoryTab): void {
    this.activeTab.set(activeTab);
  }

  public openUploadItemsModal(): void {
    const dialogRef = this.dialog.open(UploadInventoryModalComponent, {
      ...UPLOAD_INVENTORY_DIALOG_CONFIG,
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result?.success) {
        this.inventoryService.notifyRefresh();
      }
    });
  }

  public openAddProductModal(): void {
    this.dialog.open(InventoryItemModalComponent, {
      data: { mode: 'create' },
    });
  }
}
